import React from "react";
import Smiley from "../assets/smiley.svg";
import Arrow from "../assets/arrow.svg";
import Twitter from "../assets/twitter.png";
import Behance from "../assets/Behance.svg";
import Medium from "../assets/medium.png";
import Linkedin from "../assets/linkedin.png";
import Gmail from "../assets/gmail.png";
import VisibilitySensor from "react-visibility-sensor";
import { Spring } from "react-spring/renderprops";

const Contact = () => {
  return (
    <VisibilitySensor partialVisibility>
      {({ isVisible }) => (
        <Spring
          delay={100}
          to={{
            transform: isVisible ? "translateY(0)" : "translateY(20%)",
          }}
        >
          {(props) => (
            <div
              className="mx-auto flex flex-wrap justify-between w-full lg:w-5/6 py-10 pt-6 items-center"
              style={{ ...props }}
              id="Contact"
            >
              <div className="flex  lg:w-1/2 my-5 text-center lg:text-justify lg:mx-auto">
                <img className="mt-5 h-1/3  block" alt="arrow" src={Arrow} />
                <div className="lg:px-5">
                  <h1 className="text-4xl lg:text-5xl mb-8 fontRB dark-blue font-bold">
                    Contact me
                  </h1>
                  <p className="fontN" style={{ color: "#4A5F82" }}>
                    Reach out to me if you would like me to work with{" "}
                    <br className="lg:hidden" /> you, or just have a chat about
                    development, QA,
                    <br className="lg:hidden" /> crypto and even the Football
                    <span>
                      <img
                        alt="smiley"
                        src={Smiley}
                        className="w-5 h-5 inline"
                      />
                    </span>
                  </p>
                  <p
                    className="mt-7 fontN cursor-pointer font-semibold"
                    style={{ color: "#023ED4", fontSize: "18px" }}
                  >
                    <a
                      href="mailto:hey@femikolade.com"
                      target="_blank"
                      rel="noreferrer"
                    >
                      aladefaruk11@gmail.com
                    </a>
                  </p>
                </div>
              </div>
              <div className="w-full lg:w-1/2 cursor-pointer ">
                <div className=" con1 w-full flex  justify-evenly">
                  <a
                    className="lg:p-10 w-1/2 mx-5 lg:w-1/3 h-48 rounded-lg"
                    id="divm"
                    href="mailto:aladefaruk11@gmail.com"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      alt="behance"
                      src={Gmail}
                      className="w-12 h-12 lg:w-14 lg:h-14 absolute move"
                    />
                    <div className="px-5 pb-5 absolute inset-x-0 bottom-0 text-md fontN  M">
                      <h1
                        className="font-semibold"
                        style={{ color: "#34A853" }}
                      >
                        Gmail
                      </h1>
                      <h1
                        style={{ color: "#4A5F82" }}
                        className="text-xs lg:text-sm"
                      >
                        aladefaruk11@gmail.com
                      </h1>
                    </div>
                  </a>

                  <a
                    className="lg:p-10 w-1/2 mx-5 lg:w-1/3 rounded-lg"
                    id="divn"
                    href="https://www.linkedin.com/in/farukalade/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      alt="dribble"
                      src={Linkedin}
                      className="w-12 h-12 lg:w-14 lg:h-14 absolute move "
                    />
                    <div className="px-5 pb-5 absolute inset-x-0 bottom-0 text-md fontN M">
                      <h1
                        className="font-semibold"
                        style={{ color: "#0B65C2" }}
                      >
                        LinkedIn
                      </h1>
                      <h1
                        style={{ color: "#4A5F82" }}
                        className="text-xs lg:text-sm"
                      >
                        @ Faruk Alade
                      </h1>
                    </div>
                  </a>
                </div>

                <div className=" flex justify-evenly my-10">
                  <a
                    className="p-10 w-1/2 mx-5 lg:w-1/3 h-48 rounded-lg"
                    id="divo"
                    href="https://medium.com/@alade.faruk11"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      alt="dribble"
                      src={Medium}
                      className="w-12 h-12 lg:w-14 lg:h-14 absolute move"
                    />
                    <div className="px-5 pb-5 absolute inset-x-0 bottom-0 text-md fontN M">
                      <h1
                        className="font-semibold"
                        style={{ color: "#162B4D" }}
                      >
                        Medium
                      </h1>
                      <h1
                        style={{ color: "#4A5F82" }}
                        className="text-xs lg:text-sm"
                      >
                        @Alade Faruk
                      </h1>
                    </div>
                  </a>

                  <a
                    className="p-10 w-1/2 mx-5 lg:w-1/3 rounded-lg"
                    id="divp"
                    href="https://twitter.com/lamarrti"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      alt="dribble"
                      src={Twitter}
                      className="w-12 h-12 lg:w-14 lg:h-14 absolute move "
                    />
                    <div className="px-5 pb-5 absolute inset-x-0 bottom-0 text-md fontN M">
                      <h1
                        className="font-semibold"
                        style={{ color: "#0B65C2" }}
                      >
                        Twitter
                      </h1>
                      <h1
                        style={{ color: "#4A5F82" }}
                        className="text-xs lg:text-sm"
                      >
                        @ 14
                      </h1>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          )}
        </Spring>
      )}
    </VisibilitySensor>
  );
};

export default Contact;
